import { toMyViewPath } from "../me/utils/legacyLinks";

const isMyViewPath = (p) =>
  p === "/me" || p.startsWith("/me/") || p.startsWith("/me?");

/**
 * Where a notification link may take this user. /me links need a linked
 * employee, HR links need HR access; otherwise go to the user's own home
 * (null = nowhere to go). Navigating into the other route tree switches view.
 */
export const resolveNotificationLink = (link, { hasHrAccess, employeeId }) => {
  if (!link || typeof link !== "string" || !link.startsWith("/")) return null;
  const path = toMyViewPath(link);
  if (isMyViewPath(path))
    return employeeId ? path : hasHrAccess ? "/dashboard" : null;
  if (hasHrAccess) return path;
  return employeeId ? "/me" : null;
};
